import {useState, useEffect} from 'react'
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { MuiVideos, MuiChannelCard } from "./";
import { fetchFromApi } from "../utils/fetchFromApi";

const MuiChannel = () => {
  const [channelDetails, setchannelDetails] = useState([]);
  const [videos, setvideos] = useState([]);
  const { id } = useParams();
  console.log(channelDetails);


  useEffect(() => {
    fetchFromApi(`channels?part=snippet&id=${id}`).then((data) =>
      setchannelDetails(data?.items[0])
    );
    fetchFromApi(`search?channelId=${id}&part=snippet&order=date`).then(
      (data) => setvideos(data?.items)
    );
  }, [id]);


  // useEffect(() => {
  //   const fetchResults = async () => {
  //     const data = await fetchFromApi(`channels?part=snippet&id=${id}`);

  //     setchannelDetails(data?.items[0]);

  //     const videosData = await fetchFromApi(
  //       `search?channelId=${id}&part=snippet%2Cid&order=date`
  //     );

  //     setvideos(videosData?.items);
  //   };

  //   fetchResults();
  // }, [id]);

  return (
    <Box minHeight="105vh">
      <Box>
        <div
          style={{
            background:
              "linear-gradient(90deg, rgba(67,226,200,1) 0%, rgba(49,68,185,1) 0%, rgba(0,212,255,1) 100%)",
            height: "300px",
            zIndex: 10,
          }}
        />
        <MuiChannelCard channelDetails={channelDetails} marginTop="-100px" />
      </Box>
      <Box display="flex" p="2">
        <Box sx={{ ml: { sm: "100px" } }}/>
          <MuiVideos videos={videos} />
      </Box>
    </Box>
  );
};

export default MuiChannel;
